<template>
  <!-- The HTML is committed from trusted legal DOCX sources; no user content is rendered. -->
  <!-- eslint-disable-next-line vue/no-v-html -->
  <article
    class="word-document"
    v-html="content"
  />
</template>

<script>
import wordDocumentContent from '@/legal/wordDocumentContent'

export default {
  name: 'WordDocument',
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  computed: {
    content() {
      return wordDocumentContent[this.document.key] || ''
    },
  },
}
</script>

<style lang="scss">
.word-document {
  color: inherit;
  overflow-x: auto;
  font-size: 1rem;
  line-height: 1.7;
  overflow-wrap: anywhere;

  p {
    margin: 0 0 1rem;
  }

  h1,
  h2,
  h3 {
    margin: 1.5rem 0 0.75rem;
    color: inherit;
    font-size: 1.15rem;
    line-height: 1.5;
  }

  ul,
  ol {
    padding-left: 1.5rem;
    margin-bottom: 1rem;
  }

  li {
    margin-bottom: 0.5rem;
  }

  table {
    width: 100%;
    min-width: 560px;
    margin: 1rem 0 1.5rem;
    border-collapse: collapse;
  }

  th,
  td {
    padding: 0.75rem;
    border: 1px solid #d8d6de;
    vertical-align: top;
  }

  td p:last-child {
    margin-bottom: 0;
  }
}

body.dark-layout .word-document {
  th,
  td {
    border-color: #4b5263;
  }
}
</style>
